// FIXME: Update this to work with all canopy environments.
export const createLegacyCanopyLink = path => {
  const ORG = process.env.REACT_APP_ORG
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const ECOSYSTEM = process.env.REACT_APP_ECOSYSTEM

  return `https://canopy.${APP_ENV}.${ECOSYSTEM}.vnops.net/${path}?url_organization_name=${ORG}`
}

export const createSpaIconURL = (envType, spaType) => {
  return `https://cdn.ordernext.com/spa/${envType}/${spaType}/icon.svg`
}

export const createSpaLink = spa => {
  const INSTANCE_NAME = process.env.REACT_APP_INSTANCE_NAME
  const APP_ENV = process.env.REACT_APP_APP_ENV

  const protocol = 'https://'
  const prefix = spa?.subdomain?.prefix ?? ''
  const instanceName = INSTANCE_NAME
  const subdomainSuffix = spa?.subdomain?.suffix ?? ''
  const envSuffix = ['prd', 'production'].includes(APP_ENV) ? '' : `-${APP_ENV}`
  const domain = spa?.domain ?? 'ordernext.com'

  return `${protocol}${prefix}${instanceName}${subdomainSuffix}${envSuffix}.${domain}`
}
